interface JobSearchProps {
  isCloseAllowed?: boolean;
  signupAndFind?: string;
  jobsData?: any;
  categoryDetails?: any;
  hiringCount?: any;
  screenName?: string;
  isLoggedIn?: boolean;
  isCategoryPage?: boolean;
  themeType?: string;
  localization?: any;
}
export default function jobSearchStepsProps(props: JobSearchProps) {
  const {
    isCloseAllowed,
    signupAndFind,
    jobsData,
    categoryDetails,
    hiringCount,
    screenName,
    isLoggedIn,
    isCategoryPage,
    themeType,
    localization,
  } = props;
  return {
    isCloseAllowed,
    signupAndFind,
    jobsData,
    categoryDetails,
    hiringCount,
    screenName,
    isLoggedIn,
    isCategoryPage,
    themeType,
    localization,
  };
}
